<template>
    <v-container max-width="100%">
        <v-card width="100%">
            <v-card-title>
                <v-select v-model="idTabelaSelected" :items="tabelas" item-value="id_tabela" item-text="descricao"
                    :label="$t('system.tables.selectTable')">
                </v-select>
                <v-spacer></v-spacer>
                <v-btn dark color="primary" :disabled="!idTabelaSelected" @click="save">{{ $t('button.save') }}</v-btn>
            </v-card-title>
            <v-card-text>
                <h4>{{ $t('system.tables.headers.title') }}</h4>
                <v-list>
                    <v-list-item v-for="(header, h) in headersTabela" :key="`${header.id_header}-${h}`">
                        <v-list-item-content>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="3" lg="3">
                                        <v-text-field v-model="header.text" label="Texto" dense hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3" lg="3">
                                        <v-text-field v-model="header.value" label="Valor" dense hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="3" lg="3">
                                        <v-text-field v-model="header.align" label="Alinhamento" dense hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="3" lg="3">
                                        <v-checkbox v-model="header.is_sortable" label="Ordenável" dense hide-details></v-checkbox>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="3" lg="3">
                                        <v-checkbox v-model="header.is_filtrable" label="Filtrável" dense hide-details></v-checkbox>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="3" lg="3">
                                        <v-checkbox v-model="header.to_show" label="Mostrável" dense hide-details
                                            :disabled="header.align === ' d-none'"></v-checkbox>
                                    </v-col>
                                    <v-col cols="6" sm="3" md="3" lg="3">
                                        <v-text-field v-model.number="header.column_order" type="number" label="Ordem das Colunas" dense hide-details
                                            :disabled="header.align === ' d-none'"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3" lg="3">
                                        <v-text-field v-model="header.translation_key" label="Chave de Tradução" dense hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                            <v-divider></v-divider>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-btn fab dark color="primary" absolute bottom right small :disabled="!idTabelaSelected"
                    :title="$t('button.addHeader')" @click="adicionaHeader"><v-icon color="white">mdi-plus</v-icon></v-btn>
            </v-card-text>
        </v-card>


    </v-container>
</template>
<script>
import apiController from '@/utils/apiController';
import EventBus from "@/utils/eventBus";

export default {
    data: () => ({
        user: null,
        token: null,
        tabelas: [],
        headers: [],
        idTabelaSelected: null,
    }),
    computed: {
        headersTabela() {
            return this.idTabelaSelected ? this.headers.filter((h) => h.id_tabela === this.idTabelaSelected) : [];
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {
        initialize() {
            if (this.user.is_superadmin !== 1) {
                EventBus.$emit('show-alert', { mensagem: 'Usuário não autorizado, fazendo logout...', tipo: 'error' });
                setTimeout(this.logout(), 5000);
            } else {
                this.getTabelas();
            }
        },
        logout() {
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("api");
            var id = window.setTimeout(function () { }, 0);
            while (id--) {
                window.clearTimeout(id); // will do nothing if no timeout with id is present
            }
            this.$router.push({ path: "/" });
        },
        getTabelas() {
            apiController.request(apiController.endpoints.getallTabelas, {
                onSuccess: (response) => {
                    this.tabelas = response.data;
                    this.getHeaders();
                }
            });
        },
        getHeaders() {
            apiController.request(apiController.endpoints.getallHeaders, {
                onSuccess: (response) => {
                    this.headers = response.data;
                }
            });
        },
        adicionaHeader() {
            if (this.idTabelaSelected) {
                this.headers.push({
                    id_tabela: this.idTabelaSelected,
                    id_header: null,
                    text: null,
                    value: null,
                    align: null,
                    is_filtrable: false,
                    is_sortable: false,
                    to_show: false,
                    column_order: 1,
                    translation_key: null
                });
            }
        },
        save() {
            if (this.idTabelaSelected) {
                let temp = this.headersTabela.map((h) => {
                    return [
                        h.id_header,
                        h.id_tabela,
                        h.text,
                        h.value,
                        h.align,
                        h.is_sortable,
                        h.is_filtrable,
                        h.to_show,
                        h.column_order
                    ];
                })
                apiController.request(apiController.endpoints.updateHeadersbulk, {
                    data: temp,
                    onSuccess: (response) => {
                        if (response.erro) {
                            EventBus.$emit('show-alert', { mensagem: 'Erro ao salvar', tipo: 'error' });
                        } else {
                            EventBus.$emit('show-alert', { mensagem: 'Salvo com sucesso', tipo: 'success' });
                        }
                        this.initialize();
                    }
                });
            }
        }
    }
}
</script>
<style></style>